import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import { showToast } from "../utils/utils";
import {
  getQuoteStatusAdvanceNzUrl,
  getQuoteStatusAdvanceAuUrl,
  getQuoteStatusURL,
  getDashboardDataURL,
  getInvDataExportUrl,
  getDebtorInvoiceAuditLogsUrl
} from "../utils/constants/apiEndPoints";
import { checklist, commonErrMsg } from "../locales/en";
import { showToastType } from "../utils/constants/appConstants";

const initialState = {
  loading: false,
  quoteStatus: [],
  modalLoader: false,
  debtorPaymentDetails: {},
  isMenuActive: false
};

const dashboardSlice = createSlice({
  name: "dashboardTable",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setQuoteStatus(state, action) {
      state.quoteStatus = action.payload;
    },
    setIsMenuActive(state, action) {
      state.isMenuActive = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDebtorInvoiceAuditLogs.pending, (state) => {
        state.modalLoader = true;
      })
      .addCase(getDebtorInvoiceAuditLogs.fulfilled, (state, action) => {
        state.modalLoader = false;
        state.debtorPaymentDetails = action.payload.data.data;
      })
      .addCase(getDebtorInvoiceAuditLogs.rejected, (state) => {
        state.modalLoader = false;
        state.debtorPaymentDetails = {};
        // error handle here
      })

      // Add Case For getDashboardThunk -----
      .addCase(getDashboardThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getDashboardThunk.rejected, (state) => {
        state.loading = false;
      });
  }
});

export const getDashboardThunk = createAsyncThunk(
  "dashboardTable/getDashboardThunk",
  async (payload) => {
    try {
      const response = await privateAxios.get(getDashboardDataURL, {
        params: payload
      });

      return response;
    } catch {
      // handle catch here;
    }
  }
);

export const getQuoteStatusThunk = createAsyncThunk(
  "dashboardTable/getQuoteStatushunk",
  async (_, { dispatch }) => {
    try {
      const response = await privateAxios.get(getQuoteStatusURL);

      dispatch(setQuoteStatus(response.data.data));
      return response;
    } catch {
      // handle catch here;
    }
  }
);

// Async thunk to Quote stattus nz download
export const getQuoteStatusAdvanceNz = createAsyncThunk(
  "dashboardTable/getQuoteStatusAdvanceNz",
  async (payload) => {
    try {
      const response = await privateAxios.post(
        getQuoteStatusAdvanceNzUrl,
        payload,
        {
          responseType: "blob"
        }
      );
      return response;
    } catch (error) {
      if (error?.response?.data instanceof Blob) {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        showToast(json.message, showToastType.error);
      } else {
        const message = error?.response?.data?.message || error?.message;
        showToast(message, showToastType.error);
      }
    }
  }
);

// Async thunk to Quote status au download
export const getQuoteStatusAdvanceAu = createAsyncThunk(
  "dashboardTable/getQuoteStatusAdvanceAu",
  async (payload) => {
    try {
      const response = await privateAxios.post(
        getQuoteStatusAdvanceAuUrl,
        payload,
        {
          responseType: "blob"
        }
      );
      return response;
    } catch (error) {
      if (error?.response?.data instanceof Blob) {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        showToast(json.message, showToastType.error);
      } else {
        const message = error?.response?.data?.message || error?.message;
        showToast(message, showToastType.error);
      }
    }
  }
);

// Async thunk to Data Export Module
export const getDashboardDataExport = createAsyncThunk(
  "dashboardTable/dashboardDataExport",
  async (payload) => {
    try {
      const response = await privateAxios.post(
        `${getInvDataExportUrl}?${payload.queryString}`,
        null,
        {
          responseType: payload.type === "on_screen" ? "json" : "blob"
        }
      );

      if (payload.type !== "on_screen") {
        showToast(checklist?.errors?.fileDownload, showToastType.success);
      }

      return response;
    } catch {
      showToast(commonErrMsg?.item11, showToastType.error);
    }
  }
);

// Async thunk to get Debtor Invoice Audit Logs
export const getDebtorInvoiceAuditLogs = createAsyncThunk(
  "dashboardTable/getDebtorInvoiceAuditLogs",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getDebtorInvoiceAuditLogsUrl, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const { setQuoteStatus, setIsMenuActive } = dashboardSlice.actions;
export default dashboardSlice.reducer;
